import {HistoryActions} from './enums';
import {getYyyyMmDd} from './utils/date';

export const insertInsideArray = (arr, index, newItem) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

export const reactSelectStyle = ({
  hide,
  width,
  size,
  background,
  color,
  maxHeight = 140,
}) => ({
  multiValue: (base, state) =>
    state.data.isFixed ? {...base, backgroundColor: 'gray'} : base,
  multiValueLabel: (base, state) =>
    state.data.isFixed ? {...base, color: 'white', paddingRight: 6} : base,
  multiValueRemove: (base, state) =>
    state.data.isFixed ? {...base, display: 'none'} : base,

  container: (base) => ({
    ...base,
    width: width || '100%',
  }),
  control: () => ({
    display: 'flex',
    borderRadius: 0,
    border: 'none',
    backgroundColor: background || undefined,
    color: color || undefined,
    minHeight: 50,
    borderLeft: '1px solid #d6d6d6',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: size === 'large' ? 12 : 10,
    display: hide ? 'none' : 'flex',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  valueContainer: (base) => ({
    ...base,
    height: 50,
    position: 'relative',
  }),
  singleValue: (base) => ({
    ...base,
    color: color || undefined,
    textTransform: 'capitalize',
  }),
  menuList: (base) => ({
    ...base,
    textAlign: 'left',
    textTransform: 'capitalize',
    maxHeight,
  }),
  input: (base) => ({
    ...base,
    height: 20,
    padding: 0,
    marginTop: -10,
  }),
  menu: (base) => ({...base, zIndex: 9999}),
});

export const deepValue = (obj, path) =>
  path
    .replace(/\[|\]\.?/g, '.')
    .split('.')
    .filter((s) => s)
    .reduce((acc, val) => acc && acc[val], obj);

export const addParameterToURL = (url, param) =>
  (url += (url.split('?')[1] ? '&' : '?') + param);

/**
 * Format postHistory from API output string.
 * @param h
 * @returns {*}
 */
export const formatHistory = (h) => {
  let history = h.action;
  if (HistoryActions[h.action]) {
    history = HistoryActions[h.action];
    if (h.action === 'title') history = history.replace('%', h.title);
    if (h.action === 'schedule')
      history = history.replace('%', getYyyyMmDd(h.scheduledDate));
    if (h.action === 'company')
      history = history.replace(
        '%',
        h.companyId && h.companyId.companyName ? h.companyId.companyName : ''
      );
    if (h.action === 'companies')
      history = history.replace('%', h.companies.length);
    if (h.action === 'validity') {
      history.replace('%1', getYyyyMmDd(h.fromDate));
      history.replace('%2', getYyyyMmDd(h.untilDate));
    }
    // if (h.action === 'upload') history = history.replace('%', h.companies.length);
    if (h.action === 'connect')
      history = history.replace(
        '%',
        h.pageFolderId && h.pageFolderId.title ? h.pageFolderId.title : ''
      );
  }
  return history;
};
